import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmLookupClickFunction = (
  lmFormatUtilService: LMFormatUtilService,
  event: any,
  lookup: SohoLookupStatic,
  clickArguments: LookupClickFunctionClickArguments
) => {

  if (clickArguments === undefined) {
    return;
  }

  const listGridComponent = clickArguments.grid.settings.userObject();
  const column = clickArguments.column;

  if (!column.name) {
    column.name = (listGridComponent?.dataViewSet?.header && column.displayField?.label)
      ? lmFormatUtilService.formatMessageRule(column.displayField?.label, listGridComponent.dataViewSet?.header)
      : '';
  }

  const listLookupClickedEvent: LMListLookupClickedEvent = {
    dataView:      clickArguments.rowData,
    lookup,
    sourceField:   column.displayField.selectFieldId,
    selectListUrl: column.displayField.selectListUrl,
    column
  };

  listGridComponent.listLookupClicked.emit(listLookupClickedEvent);
};
